import { Navigate, useParams } from 'react-router-dom';

import { ReferralRequestSubmit as ReferralRequestSubmitFeature } from '../../../features/referral-request/referral-request-submit';

const ReferralRequestSubmit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) return <Navigate to="/" />;

  return <ReferralRequestSubmitFeature id={id} />;
};

export { ReferralRequestSubmit };
